import { EMoneySource } from '../../../../../../types/reducers/user';

import { IMoneySourceTabProps } from '../../types';
import { TMoneySourcesState } from '../../../../../../reducers/v2';

export const getSources = (
  availableSources: TMoneySourcesState,
  cb: (v: EMoneySource) => void,
): IMoneySourceTabProps[] => {
  const activeMoneySource = availableSources.find(({ selected }) => selected)?.type;
  const moneySourceTypes = availableSources.map(({ type }) => type);

  return [
    {
      disabled: moneySourceTypes.length === 1 && moneySourceTypes.includes(EMoneySource.Self),
      active: activeMoneySource === EMoneySource.Master,
      label: 'Со счёта агентства',
      handleClick: () => cb(EMoneySource.Master),
    },
    {
      disabled: moneySourceTypes.length === 1 && moneySourceTypes.includes(EMoneySource.Master),
      active: activeMoneySource === EMoneySource.Self,
      label: 'С личного счёта',
      handleClick: () => cb(EMoneySource.Self),
    },
  ];
};
